import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs';
import { imageUploadConst, typeList } from 'src/assets/config/constants';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrl: './image-upload.component.css',
    standalone: false
})
export class ImageUploadComponent {

  // @Input()
  loader: boolean = false;

  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  dtOptions: Config = {};
  model: any = {

  };
  selectedType: any = {};
  barWidth: string = '0%';
  uploadImages: any = [];
  previewImages: any = {};
  uploadedFiles: Array<File> = [];
  invalidImg: boolean = false;
  validationError: string = '';
  private _renderer: Renderer2;
  uploadedImageType = "";
  typeList: any = typeList;
  copyClass: string | null = imageUploadConst.copyClass;
  copyLinkLabel: string | null = imageUploadConst.copyLinkLabel;
  @ViewChild('imageForm') form;
  constructor(private http: HttpClient, private toastr: ToastrService, private router: Router) {


    this.breadcrumb = {
      'mainlabel': 'Offer Management',
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      //  paging:false
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search offer'
      }
    }
  }

  toggleCustomizer(event) {
    const element = document.getElementById('customizer');
    // console.log(element.classList);
    // element.classList.add('hll');
    // console.log(element.classList);
    if (element && element.classList.contains('open')) {
      element.classList.remove('open');
    } else {
      element.classList.add('open');
    }

    if (this.isOrderViewPage()) {
      this.model.type = 'Document/Image';
    } else {
      this.model.type = 'select';
    }
  }

  isOrderViewPage(): boolean {
    const path = this.router.url.split('?')[0]; // remove query params
    return /^\/order\/view\/[^\/]+$/.test(path);
  }

  changeType() {
    this.selectedType = this.typeList.find((element) => element.name === this.model.type) || {};
    if (this.model.type == 'select') {
      this.selectedType = {};
    }
    this.validationError = '';
    if (this.uploadedFiles.length) {
      this.validateSelectedFile();
    }
  }

  reset() {

    this.model = {
      type: 'select',
      image: null,
      imageUrl: '',
    };

    this.selectedType = undefined;
    this.uploadedFiles = [];
    this.previewImages = {
      url: '',
      height: undefined,
      width: undefined,
      fileSizeMB: undefined,
      isvalid: undefined,
    };

    this.barWidth = '0%';
    this.validationError = '';
    this.copyClass = imageUploadConst.copyClass;
    this.copyLinkLabel = imageUploadConst.copyLinkLabel;

    this.form.resetForm();
  }

  fileChange(ev) {
    this.previewImages = {};
    this.barWidth = '0%';
    this.model.imageUrl = '';
    this.validationError = '';
    const files = Array.from((ev?.target as HTMLInputElement)?.files || []) as File[];
    this.uploadedFiles = files;
    const element = files[0];
    if (!element) {
      return;
    }

    if (!this.isMimeTypeValid(element)) {
      this.invalidImg = false;
      this.validationError = this.getMimeTypeErrorMessage();
      this.previewImages = {
        fileSizeMB: this.bytesToMB(element.size),
        isvalid: false
      };
      return;
    }

    if (this.selectedType?.type !== 'Image') {
      this.invalidImg = this.validateSelectedFile();
      this.previewImages = {
        fileSizeMB: this.bytesToMB(element.size),
        isvalid: this.invalidImg
      };
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(element);
    reader.onload = (evn: any) => {
      const img = new Image();
      const objectUrl = window.URL.createObjectURL(element);
      img.src = objectUrl;
      img.onload = () => {
        const isValidImage = this.validateSelectedFile(img.width, img.height);
        this.invalidImg = isValidImage;
        this.previewImages = {
          height: img.height,
          width: img.width,
          fileSizeMB: this.bytesToMB(element.size),
          url: evn.target.result,
          isvalid: isValidImage
        };
        window.URL.revokeObjectURL(objectUrl);
      };
      img.onerror = () => {
        this.invalidImg = false;
        this.validationError = 'Unable to read selected image.';
        this.previewImages = {
          url: evn.target.result,
          isvalid: false
        }
        window.URL.revokeObjectURL(objectUrl);
      };
    };
  }


  // fileChange(ev) {

  //   if ((ev.target.files.length + this.previewImages.length) > 4) {
  //     alert("Please select max 4 files.");
  //     // e.preventDefault();
  //   } else {
  //     // console.log(this.uploadedFiles);
  //     if (this.uploadedFiles != undefined) {

  //       this.uploadedFiles = [...this.uploadedFiles, ...ev.target.files];
  //     } else {
  //       this.uploadedFiles = ev.target.files;
  //     }

  //     for (let i = 0; i < ev.target.files.length; i++) {
  //       const element = ev.target.files[i];
  //       let reader = new FileReader();

  //       reader.readAsDataURL(element);
  //       reader.onload = (evn: any) => {
  //         // To get image dimensions
  //         const img = new Image();
  //         img.src = window.URL.createObjectURL(element);
  //         let interval = setInterval(() => {
  //           if (img.height != 0 && img.width != 0) {
  //             this.previewImages.push({
  //               height: img.height,
  //               width: img.width,
  //               url: evn.target.result
  //             });
  //             clearInterval(interval);
  //           }
  //         }, 1000);
  //       }
  //     }
  //   }
  // }
  checkImageConstraints() {
    const imageFile = this.uploadedFiles?.[0];
    const width = this.previewImages?.width;
    const height = this.previewImages?.height;

    if (!imageFile || !width || !height) {
      this.invalidImg = false;
      this.validationError = 'Please wait until image preview is loaded.';
      this.previewImages = {
        ...this.previewImages,
        isvalid: false
      };
      return false;
    }

    this.invalidImg = this.validateSelectedFile(width, height);
    this.previewImages = {
      ...this.previewImages,
      isvalid: this.invalidImg
    };
    return this.invalidImg;
  }

  validateSelectedFile(width?: number, height?: number): boolean {
    const file = this.uploadedFiles?.[0];
    if (!file) {
      this.validationError = 'Please select a file.';
      return false;
    }

    if (!this.isMimeTypeValid(file)) {
      this.validationError = this.getMimeTypeErrorMessage();
      return false;
    }

    const sizeValid = this.isSizeValid(file, this.selectedType?.maxSizeMB);
    if (!sizeValid) {
      this.validationError = `Please upload ${this.selectedType?.type || 'file'} up to ${this.selectedType?.maxSizeMB} MB only.`;
      return false;
    }

    if (this.selectedType?.type !== 'Image') {
      this.validationError = '';
      return true;
    }

    if (!width || !height) {
      this.validationError = 'Please wait until image preview is loaded.';
      return false;
    }

    const ratioValid = this.isRatioValid(width, height, this.selectedType?.ratio);
    if (!ratioValid) {
      this.validationError = `Please upload image with ratio ${this.selectedType?.ratio}.`;
      return false;
    }

    this.validationError = '';
    return true;
  }

  getAllowedMimeTypes(): string[] {
    const selectedType = this.selectedType?.type;

    if (selectedType === 'Image') {
      return ['image/png', 'image/jpg', 'image/jpeg'];
    }
    if (selectedType === 'GIF') {
      return ['image/gif'];
    }
    if (selectedType === 'Video') {
      return ['video/mp4'];
    }
    if (selectedType === 'Audio') {
      return ['audio/mpeg', 'audio/mp3'];
    }
    if (selectedType === 'Document/Image') {
      return ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'application/pdf'];
    }

    return [];
  }

  getAllowedExtensions(): string[] {
    const selectedType = this.selectedType?.type;

    if (selectedType === 'Image') {
      return ['png', 'jpg', 'jpeg'];
    }
    if (selectedType === 'GIF') {
      return ['gif'];
    }
    if (selectedType === 'Video') {
      return ['mp4'];
    }
    if (selectedType === 'Audio') {
      return ['mp3'];
    }
    if (selectedType === 'Document/Image') {
      return ['png', 'jpg', 'jpeg', 'gif', 'pdf'];
    }

    return [];
  }

  isMimeTypeValid(file: File): boolean {
    const allowedMimeTypes = this.getAllowedMimeTypes();
    if (!allowedMimeTypes.length) {
      return true;
    }

    if (allowedMimeTypes.includes(file.type)) {
      return true;
    }

    const fileExtension = (file.name || '').split('.').pop()?.toLowerCase() || '';
    return this.getAllowedExtensions().includes(fileExtension);
  }

  getMimeTypeErrorMessage(): string {
    if (this.selectedType?.type === 'GIF') {
      return 'Please upload GIF files only.';
    }
    if (this.selectedType?.type === 'Video') {
      return 'Please upload MP4 files only.';
    }
    if (this.selectedType?.type === 'Audio') {
      return 'Please upload MP3 files only.';
    }
    if (this.selectedType?.type === 'Document/Image') {
      return 'Please upload PNG/JPG/JPEG/GIF/PDF files only.';
    }
    return 'Please upload PNG/JPG/JPEG files only.';
  }

  getFileAccept(): string {
    if (this.selectedType?.type === 'Image') {
      return 'image/png,image/jpg,image/jpeg';
    }
    if (this.selectedType?.type === 'GIF') {
      return 'image/gif';
    }
    if (this.selectedType?.type === 'Video') {
      return 'video/mp4';
    }
    if (this.selectedType?.type === 'Audio') {
      return 'audio/mpeg,audio/mp3,.mp3';
    }
    if (this.selectedType?.type === 'Document/Image') {
      return 'image/png,image/jpg,image/jpeg,image/gif,application/pdf';
    }
    return '';
  }

  isRatioValid(width: number, height: number, ratio: string): boolean {
    const [ratioWidth, ratioHeight] = (ratio || '').split(':').map(Number);
    if (!ratioWidth || !ratioHeight) {
      return true;
    }
    return width * ratioHeight === height * ratioWidth;
  }

  isSizeValid(file: File, maxSizeMB: number): boolean {
    if (!maxSizeMB) {
      return true;
    }
    return file.size <= maxSizeMB * 1024 * 1024;
  }

  bytesToMB(sizeInBytes: number): string {
    return (sizeInBytes / (1024 * 1024)).toFixed(2);
  }
  upload() {
    const isValidFile = this.validateSelectedFile(
      this.previewImages?.width,
      this.previewImages?.height
    );

    if (!isValidFile) {
      this.toastr.error(this.validationError || "Please select a valid file.", '', {
        timeOut: 3000,
      });
      return;
    }

    if (this.uploadedFiles != undefined && this.uploadedFiles.length != 0) {
      let formData = new FormData();
      formData.append("name", "product");
      formData.append("type", this.model.type.split('-')[0]);

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        // formData.append("banner", this.uploadedFiles[i], this.uploadedFiles[i].name);
        formData.append("image", this.uploadedFiles[i], this.uploadedFiles[i].name);
      }

      this.uploadedImageType = this.model.type;

      this.http.post(environment.baseAPIHost + '/admin/upload', formData, {
        reportProgress: true,
        observe: "events"
      })
        .pipe(map(
          event => {
            if (event.type == HttpEventType.UploadProgress) {
              console.log(HttpEventType.UploadProgress);
              this.barWidth = Math.round((100 / (event.total || 0) * event.loaded)) + '%';
              if (event.total == event.loaded) {

              }
            } else if (event.type == HttpEventType.Response) {
              // this.isImageSelected = true;
              console.log(event.body['data'].imageUrl);

              for (let i = 0; i < event.body['data'].imageUrl.length; i++) {
                const element = event.body['data'].imageUrl[i];
                this.model.imageUrl = element;
                // this.uploadImages.push(element);
              }
            }
          }
        ))

        .subscribe({
          next: (value) => {
            console.log(value);
          },
          error: (error) => {
            console.error(error);
          },
        })
    } else {
      console.log('ESSSSS');

    }

  }
  deleteImage(i: any, item: any) {
    this.previewImages = {};
    this.uploadedFiles = [];
  }
  saveImages(valid) {
    if (valid) {
      let parameter: any = {
        methodType: "POST",
      }
    }
  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');

    this.copyClass = imageUploadConst.copyClassAfterCopy;
    this.copyLinkLabel = imageUploadConst.copyLinkAfterCopy;
    setTimeout(() => {
      this.copyClass = imageUploadConst.copyClass;
      this.copyLinkLabel = imageUploadConst.copyLinkLabel;
      document.body.removeChild(selBox);
    }, 3000);

  }
}
